import {__DEBUG__} from '~/utils/env';
export const actionList = [];

export default function actionRecorder(blacklist = [], actions = actionList) {
  return store => next => action => {
    const {type} = action;
    if (blacklist.indexOf(type) === -1) {
      let {payload} = action;
      if (Object.prototype.hasOwnProperty.call(action, 'meta')) {
        payload = action.meta;
      }
      actions.push({payload, type});
    }
    if (__DEBUG__) {
      // eslint-disable-next-line no-console
      console.log(action);
    }
    return next(action);
  };
}
